import React, { useState } from "react";
import { PlanExtras } from "@plans-templates/plan-extras";
import { TextLink } from "@vds/buttons";
import { updateSCTags } from "../../service/dtmTag";
import { tempVzdlSCData, updateDetailValue } from "../../service/vzdl";
function GiftCardModal({
  title = "",
  expireDate = new Date(2025, 6, 6),
  //handleDetailClose,
}) {
  const [opened, setOpened] = useState(false);
  const [isCloseBtnClick, setIsCloseButton] = useState(false);


  const handleCloseSignClick = (e)=> {
   updateDetailValue(title + ' - details')
    if(e === false && !isCloseBtnClick) {
      updateSCTags('close sign') 
    }else {
      setIsCloseButton(false)
    }
  }
  
  const handleCloseButton=(e)=>{
    setIsCloseButton(true)
    setOpened(false);
    updateDetailValue(title + ' - details')
    e.stopPropagation()
    updateSCTags("close button")
  }
  
  return (
    <PlanExtras
      opened={opened}
      toggleButton={(
        <span onClick={(e) => setOpened(true)}>
          <TextLink tabIndex="0" role="button" ariaLabel={"Details " + title} >Details</TextLink>
        </span>
      )}
      onOpenedChange={(e) => {handleCloseSignClick(e)}}
    
      title={{
        children: title,
        primitive:'h2'
      }}
      productImage={{
        src: "https://www.verizon.com/content/dam/verizon/personal/accordion-images/verizongiftcardnew.png",
        alt: "Verizon Gift Card",
      }}
      intro={{
        body: {
          children: (
            <>
              <p>Verizon Gift Cards can be used online or in-store to get the hottest smartphones, tablets, cases, headphones, speakers and much more.</p>
              <p>They can even be used to pay your Verizon Wireless or Fios bill.</p>
              <p>Gift cards do not expire and are not subject to dormancy or other fees.</p>
              <p>Gift Card bonus fulfillment will be 65 days after installation,and must be redeemed within 60 days after fulfillment.Bonus is non-exchangable & non-refundable.</p>
            </>
          )
        }
      }}
      disclosures={{
        // children: `Must install and maintain eligible Fios services in good standing for 65 days and register no later that ${expireDate.getMonth()}.${expireDate.getDate()}.${expireDate.getFullYear() % 100}, whichever is first. Gift Card emailed within 48 hours of registration. We reserve the right to charge back the amount of the Gift Card if eligible service is canceled w/in 189 days. Other Gift Card terms and conditions apply. One offer per eligible Verizon account.`
      }}
      buttonData={{
        primary: {
          children: "Close",
          onClick: (e) =>handleCloseButton(e)
        }
      }}
    />
  )
}

export default GiftCardModal;
